export default {
  finances: [],
  financeInfo: {},
  article: {},
  articles: [],
  myArticles: [],
  articlesOnSale: [],
  myArticlesFilter: {},
  articleVariations: [],
  attribute: {},
  attributes: [],
  attributeValues: [],
  bank: {},
  banks: [],
  blog: {},
  blogs: [],
  recentBlogs: [],
  brand: {},
  brands: [],
  allBrands: [],
  categories: [],
  categoriesFilters: {},
  category: {},
  commercialists: [],
  companies: [],
  company: {},
  countries: [],
  country: {},
  currencies: [],
  currency: {},
  customerBankAccount: {},
  customerBankAccounts: [],
  expressPost: {},
  expressPosts: [],
  highlightedBrand: {},
  highlightedCategories: [],
  interestsArea: {},
  interestsAreas: [],
  jumbotrons: [],
  measurementUnits: [],
  messages: [],
  newlyAddedArticles: [],
  newlyAddedArticlesFilter: {},
  order: null,
  orders: [],
  pager: {
    currentPage: 1,
    totalItems: 0,
    totalPages: 1,
  },
  parentCompanies: [],
  productSale: {},
  productSales: [],
  profile: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {},
  quickArticle: null,
  recentArticles: [],
  reviews: [],
  searchArticles: [],
  searchViewArticles: [],
  searchFilters: {
    attributes: [],
    brands: [],
    categories: [],
    maxPriceInThisCategory: 0,
    minPriceInThisCategory: 100000,
  },
  selectedUser: {},
  shippingAddress: {},
  shippingAddresses: [],
  shippingAddressesFiltered: [],
  shippingTowns: [],
  shoppingCarts: [],
  shoppingCart: {},
  simplifiedCategories: [],
  subCompaniesByParent: [],
  tab: {},
  tabs: [],
  taxes: [],
  terms: [],
  token: localStorage.getItem('token') || null,
  topBrands: [],
  town: {},
  towns: [],
  unreadMessagesCount: 0,
  userArticles: [],
  userArticlesFilter: {},
  userProfile: { userData: {}, shippingInfoData: {} },
  users: [],
  userShippingInfo: {},
  wishlist: [],
  userFiles: [],

  // Tags
  mostPopularTags: [],

  // Complaints
  complaints: [],

  // Parameters
  freeShippingAmount: null,
  freeShippingEnabled: false,
  allowOrderingStockZero: false,
  useDefaultLanguage: false,
  defaultLanguage: null,
  languages: [],

  // Modals
  outOfStockModal: { isVisible: false },
};
